<div class="p-g form-container panel-div">
  <form [formGroup]="bookingCancelForm" class="p-g-12">
    <div class="p-g-12">
      <div class="p-g">
        <div class="form-field p-g-12">
          <div class="form-control">
            <input type="text" [placeholder]="labelCancellation" pInputText formControlName="cancelReason" />
          </div>
          <div class="form-errors alert alert-danger" [hidden]='!packageApiError[0]["pickupLocationName"]'>
            <div *ngFor="let ErrorMessage of packageApiError['pickupLocationName']">
              {{ErrorMessage.message}}
            </div>
          </div>
          <div class="form-errors"
            *ngIf="bookingCancelForm.controls.cancelReason.errors  && (bookingCancelForm.controls.cancelReason.dirty || bookingCancelForm.controls.cancelReason.touched)">
            <div [hidden]="!bookingCancelForm.controls.cancelReason.errors.required" translate>
              cancel_reason_req
            </div>
          </div>
        </div>
      </div>
      <div class="form-buttons p-g-12 p-g-nopad">
        <button class="negative-button" pButton type="button" icon="fa fa-close" [label]="labelCancel"
          (click)="cancel()"></button>
        <button pButton type="button" [label]="labelSave" icon="fa fa-check" [disabled]="!bookingCancelForm.valid"
          (click)="cancelBooking()"></button>
      </div>
    </div>

  </form>
</div>
